import React from 'react';
import { Box, Text, TextLink } from 'braid-design-system';

import SeekLogo from './SeekLogo/SeekLogo';

import useAppConfig from '../../../../../../hooks/useAppConfig';

import * as styles from './Logo.css';

export function Logo() {
  const { ROUTER_BASE_NAME } = useAppConfig();

  return (
    <Box className={styles.logo}>
      <Text>
        <TextLink href={`${window.location.origin}${ROUTER_BASE_NAME}`}>
          <SeekLogo />
        </TextLink>
      </Text>
    </Box>
  );
}

export default Logo;
